import type { LinkType } from '@/frontend-types'
import { linkTypeToIcon } from '@/helpers/transforms'
import type { FC } from 'react'
import { LinkIcon } from '../atoms/LinkIcon'
import ContentBlockWrapper from '../molecules/ContentBlockWrapper'

export type LinkColumnsBlockProps = {
	links: LinkType[]
}

const LinkColumnsBlock: FC<LinkColumnsBlockProps> = ({ links }) => {
	const layoutClasses =
		'col-span-full tablet-p:col-span-4 layout-narrow:tablet-l:col-span-4 layout-wide:tablet-l:col-span-6'

	return (
		<ContentBlockWrapper blockTypes={['component', 'cta']} gridClassName="gap-y-xl">
			{links.map((link, index) => (
				<div key={link.href || index} className={layoutClasses}>
					<LinkIcon {...link} icon={linkTypeToIcon(link)} intent="primary" />
				</div>
			))}
		</ContentBlockWrapper>
	)
}

export default LinkColumnsBlock
